@import '../../shared/frame';

.markdown {
  padding: 3em;
  font-size: 1.5em !important;
  line-height: 1.2em !important;
}

.markdown h1 {
  font-size: 3em;
  font-weight: 900;
}

.markdown h2 {
  font-size: 2.5em;
  font-weight: 900;
}

.markdown h3 {
  font-size: 2em;
  font-weight: 900;
}
